import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './LegalPage.css';


const NDATemplate = () => {
  return (
    <>
      <Header />
      <div className="legal-page">
        <div className="legal-container">
          <Link to="/" className="back-link">← Back to Home</Link>
          
          <h1 className="legal-title">Non-Disclosure Agreement (NDA)</h1>
          <p className="legal-date">Last Updated: January 27, 2026</p>
          
          <div className="legal-content">
            <p className="legal-intro">
              This Non-Disclosure Agreement ("Agreement") is entered between:
            </p>
            
            <p className="legal-intro">
              <strong>VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED</strong> (operating as WhiteLabelDevs), having its registered address at
              2 Maa Pitambara Complex, Dwarika Green Phase 2, Agra Bamroli Road, UP – 28009
              and the client/user ("Receiving Party").
            </p>
            
            <section className="legal-section">
              <h2>1. Definition of Confidential Information</h2>
              <p>Includes but not limited to:</p>
              <ul>
                <li>Business plans, ideas, strategies</li>
                <li>Source code, software architecture</li>
                <li>Client data, credentials, documents</li>
                <li>Pricing, proposals, and processes</li>
                <li>Server access credentials and hosting configurations</li>
                <li>Database structures and proprietary algorithms</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>2. Obligations</h2>
              <p>The receiving party agrees to:</p>
              <ul>
                <li>Keep all confidential information strictly private</li>
                <li>Not disclose to any third party</li>
                <li>Use information only for project purposes</li>
                <li>Implement reasonable security measures to protect confidential data</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>3. Exclusions</h2>
              <p>Does not apply to information that:</p>
              <ul>
                <li>Is publicly available</li>
                <li>Was already known before disclosure</li>
                <li>Is required by law to be disclosed</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>4. Data Protection</h2>
              <p>We implement strict internal access controls and security practices for all white-label and hosting services.</p>
            </section>
            
            <section className="legal-section">
              <h2>5. Ownership</h2>
              <p>All confidential material remains the property of the disclosing party.</p>
            </section>
            
            <section className="legal-section">
              <h2>6. Term</h2>
              <p>This NDA remains valid for 5 years after project completion.</p>
            </section>
            
            <section className="legal-section">
              <h2>7. Jurisdiction</h2>
              <p>Governed by the laws of India.</p>
            </section>
          </div>
          
          <div className="legal-footer">
            <p><strong>VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED</strong></p>
            <p>Operating as: WhiteLabelDevs</p>
            <p>CIN: U62090UP2026PTC241378</p>
            <p>2 Maa Pitambara Complex, Dwarika Green Phase 2, Agra Bamroli Road, UP 282009</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NDATemplate;